import { getIconSVG, PplIconService } from '../icon.service';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MemoizeLast } from '@ppl/utils/memoize.utils';
import { first } from 'rxjs/operators';
import type { Observable } from 'rxjs';

@Component({
  selector: 'ppl-svg-icon',
  templateUrl: './svg-icon.component.html',
  styleUrls: ['./svg-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PplSvgIconComponent {

  @Input() icon: string;
  @Input() width: number;
  @Input() height: number;

  iconsLoaded$: Observable<boolean>;

  @MemoizeLast<PplSvgIconComponent>(['icon'])
  get iconSVG() {
    const icon = this.iconService.icons[this.icon];
    if (icon) {
      const iconSVG = getIconSVG(icon.innerHTML);
      return this.sanitizer.bypassSecurityTrustHtml(iconSVG);
    } else {
      console.warn(`No svg icon with name: ${this.icon}`);
      return '';
    }
  }

  constructor(
    private sanitizer: DomSanitizer,
    private iconService: PplIconService
  ) {
    this.iconsLoaded$ = this.iconService.isLoaded$.pipe(first(value => value));
  }
}
